'use client'

import Link from 'next/link'

/**
 * The shared body of every route segment's `error.tsx`.
 *
 * `.agents/checks.sh` requires an `error.tsx` next to every `page.tsx`, but it
 * only checks that the file exists — not what is in it. Keeping the markup here
 * and re-exporting from each segment means copy, tokens and a11y are edited once
 * instead of fifteen times.
 */
export function SegmentError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div
      role="alert"
      className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-24 text-center"
    >
      <h1 className="font-medium text-lg">Coś poszło nie tak</h1>
      <p className="max-w-prose text-muted-foreground text-sm">
        Nie udało się wczytać tej sekcji. Spróbuj ponownie.
      </p>
      {error.digest ? (
        <p className="font-mono text-muted-foreground/70 text-xs">ID: {error.digest}</p>
      ) : null}
      {/* The site chrome (TopHeader) lives inside each page.tsx, not in the layout,
          so it is gone while this boundary is showing. Without an explicit way out,
          `reset` is the only control — and it re-throws whenever the cause persists.
          Moving the chrome into a layout is P1 work; until then the "back home" link
          is what keeps a failed segment from being a dead end. */}
      <div className="flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={reset}
          className="rounded-full border border-border px-5 py-2 text-sm transition-colors hover:bg-muted"
        >
          Spróbuj ponownie
        </button>
        <Link
          href="/"
          className="rounded-full border border-border px-5 py-2 text-sm transition-colors hover:bg-muted"
        >
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  )
}
